export const zingayaWidgetId = '6e1655b5a3cc6179bf39245898984ab1';
export const nonRussiaSpeakingLocales = [
  'en-us',
  'en-gb',
  'en-ie',
  'es',
  'pl',
  'de',
  'tr',
  'uk-ua',
];
